/* eComHQ base theme behaviour (owner, October 17, 2026). Fixed file; see shopify/base-theme/README.md.
   Alert bar visit state and date, header menu and dialogs, variant selection, gallery, Add to Cart through the shared
   cart drawer (shopify/cart-drawer: window.EHQCart), and the unified sticky Add to Cart bar. */
(function () {
  'use strict';
  var root = document.documentElement;
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var money = function (cents) { var d = cents / 100; return '$' + (d % 1 ? d.toFixed(2) : String(d)); };
  var setVar = function (name, px) { root.style.setProperty(name, Math.round(px) + 'px'); };

  /* Alert bar: tomorrow's date (the cart drawer shows the same one) and the first-visit or later-day state. */
  function tomorrow() {
    var d = new Date(); d.setDate(d.getDate() + 1);
    var n = d.getDate(), m = n % 100, suffix = (m >= 11 && m <= 13) ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
    return d.toLocaleString('en-US', { month: 'short' }) + ' ' + n + suffix;
  }
  function visitState() {
    var forced = new URLSearchParams(location.search).get('visit');
    if (forced === 'first' || forced === 'return') return forced;
    try {
      var key = 'ehq-first-visit', now = Date.now(), first = Number(localStorage.getItem(key)) || now;
      localStorage.setItem(key, String(first));
      return new Date(first).toDateString() !== new Date(now).toDateString() ? 'return' : 'first';
    } catch (e) { return 'first'; }
  }
  var alertBar = $('[data-ehq-alert]');
  if (alertBar) {
    alertBar.dataset.visit = visitState();
    $$('[data-ehq-date]', alertBar).forEach(function (n) { n.textContent = tomorrow(); });
    var measureAlert = function () { setVar('--ehq-alert-h', alertBar.getBoundingClientRect().height); };
    measureAlert();
    if (window.ResizeObserver) new ResizeObserver(measureAlert).observe(alertBar);
  }

  /* Dialogs: header menu, size chart. The sticky bar hides while one is open. */
  function syncDialogs() { document.body.classList.toggle('ehq-dialog-open', $$('dialog[open]').some(function (d) { return !d.matches('[data-ehq-cart]'); })); }
  function openDialog(d, button) {
    if (!d || d.open) return;
    d.showModal(); syncDialogs();
    if (button) button.setAttribute('aria-expanded', 'true');
    d.addEventListener('close', function once() { d.removeEventListener('close', once); syncDialogs(); if (button) button.setAttribute('aria-expanded', 'false'); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var menuOpen = t.closest('[data-ehq-menu-open]');
    if (menuOpen) { openDialog($('[data-ehq-menu]'), menuOpen); return; }
    if (t.closest('[data-ehq-menu-close],[data-ehq-dialog-close]')) { var d = t.closest('dialog'); if (d) d.close(); return; }
    var opener = t.closest('[data-ehq-dialog-open]');
    if (opener) { openDialog(document.getElementById(opener.getAttribute('data-ehq-dialog-open')), opener); return; }
    if (t.matches('dialog.ehq-menu,dialog.ehq-dialog')) t.close();
  });

  /* Add to Cart: one request, then the shared drawer. drawer.js shows the spinner on the pressed button from the request itself. */
  function addToCart(form, button) {
    var body = new FormData(form);
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function () { if (window.EHQCart) window.EHQCart.open(); else location.href = '/cart'; })
      .catch(function (err) { var p = $('[data-cart-error]'); if (p) { p.textContent = err.message; p.hidden = false; setTimeout(function () { p.hidden = true; }, 5000); } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-ehq-form],[data-ehq-quick-add]')) return;
    e.preventDefault();
    addToCart(form, e.submitter);
  });

  /* Product page. */
  var section = $('[data-ehq-product]');
  if (!section) return;
  var data = JSON.parse(($('[data-ehq-product-json]', section) || {}).textContent || '{}');
  var form = $('[data-ehq-form]', section), select = $('[data-ehq-variant-select]', section), atc = $('[data-ehq-atc]', section);
  var variants = data.variants || [], current = variants.filter(function (v) { return v.id === data.selected; })[0] || variants[0];
  var basicMedia = {}; variants.forEach(function (v) { if (v.media) basicMedia[v.media] = true; });

  function chosen() { return $$('[data-ehq-option]', section).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
  function findVariant() {
    var want = chosen(), groups = $$('[data-ehq-option]', section);
    if (!groups.length) return current;
    return variants.filter(function (v) { return groups.every(function (fs, i) { return v.options[Number(fs.dataset.ehqOption)] === want[i]; }); })[0];
  }
  function paintPrices(v) {
    $$('[data-ehq-pack-contents]').forEach(function(n){ n.textContent=v.contents || ''; });
    $$('[data-ehq-price]').forEach(function (row) {
      var was = $('[data-ehq-was]', row), now = $('[data-ehq-now]', row), badge = $('[data-ehq-badge]', row), save = v.compare - v.price;
      if (now) now.textContent = money(v.price);
      if (was) { was.textContent = money(v.compare); was.hidden = !(v.compare > v.price); }
      if (badge) { badge.textContent = 'Save ' + money(save); badge.hidden = !(save > 0); }
    });
    $$('[data-ehq-save]').forEach(function (n) { n.textContent = String(Math.round((v.compare - v.price) / 100)); });
    $$('[data-ehq-follow-variant]').forEach(function (i) { i.value = v.id; });
  }
  /* Pack tiles show the picture and price of that pack in the currently chosen other options (a colour). */
  function paintPackTiles(v) {
    $$('.ehq-opt--pack[data-ehq-option]', section).forEach(function (fs) {
      var pos = Number(fs.dataset.ehqOption);
      $$('[data-ehq-value]', fs).forEach(function (label) {
        var want = v.options.slice(); want[pos] = label.dataset.ehqValue;
        var m = variants.filter(function (x) { return x.options.every(function (o, i) { return o === want[i]; }); })[0];
        if (!m) return;
        var img = $('.ehq-val__pic img', label);
        if (img && m.img) { img.removeAttribute('srcset'); img.src = m.img; }
        var now = $('.ehq-price__now', label), was = $('.ehq-price__was', label), save = $('.ehq-price__save', label);
        if (now) now.textContent = money(m.price);
        if (was) was.textContent = money(m.compare);
        if (save) save.textContent = 'Save ' + money(m.compare - m.price);
      });
    });
  }
  function selectVariant(v, fromUser) {
    if (!v) { if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; } return; }
    current = v;
    if (select) select.value = v.id;
    if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add to Cart' : 'Sold out'; }
    $$('[data-ehq-option]', section).forEach(function (fs) { var c = $('input:checked', fs), out = $('[data-ehq-opt-value]', fs); if (c && out) out.textContent = c.value; });
    paintPrices(v);
    paintPackTiles(v);
    gallery.showVariant(v, fromUser);
    if (fromUser && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
  }
  section.addEventListener('change', function (e) { if (e.target.closest('[data-ehq-option]')) selectVariant(findVariant(), true); });
  if (current) paintPackTiles(current);

  /* Gallery: swipe track, dot pager inside the image on a phone, thumbnail rail with a more-images cue on desktop.
     A variant's basic image shows only while that variant is selected; shared campaign media always shows. */
  var gallery = (function () {
    var g = $('[data-ehq-gallery]', section), track = g && $('[data-ehq-track]', g), rail = g && $('[data-ehq-rail]', g), dots = g && $('[data-ehq-dots]', g);
    if (!track) return { showVariant: function () {} };
    var slides = function () { return $$('[data-ehq-slide]', track).filter(function (s) { return !s.hidden; }); };
    var thumbs = function () { return rail ? $$('[data-ehq-thumb]', rail).filter(function (t) { return !t.hidden; }) : []; };
    var index = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
    function go(i, smooth) { track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); }
    function buildDots() {
      if (!dots) return;
      var n = slides().length; dots.innerHTML = '';
      if (n < 2) return;
      for (var i = 0; i < n; i++) { var b = document.createElement('button'); b.type = 'button'; b.tabIndex = -1; b.dataset.i = i; dots.appendChild(b); }
    }
    function railCue() {
      if (!rail) return;
      var over = rail.scrollHeight > rail.clientHeight + 4, top = rail.scrollTop > 4, bottom = rail.scrollTop + rail.clientHeight < rail.scrollHeight - 4;
      var more = []; if (over && top) more.push('prev'); if (over && bottom) more.push('next');
      if (more.length) rail.setAttribute('data-more', more.join(' ')); else rail.removeAttribute('data-more');
      var box = rail.parentNode;
      $$('.rail-step', box).forEach(function (s) { s.classList.toggle('is-on', more.indexOf(s.dataset.dir) >= 0); });
    }
    function mark() {
      var i = index();
      $$('button', dots || document.createElement('i')).forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      thumbs().forEach(function (t, k) {
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
        if (k === i && rail && rail.clientHeight) {
          var fade = 40, top = t.offsetTop - rail.offsetTop, bottom = top + t.offsetHeight;
          if (top < rail.scrollTop + fade) rail.scrollTop = Math.max(0, top - fade);
          else if (bottom > rail.scrollTop + rail.clientHeight - fade) rail.scrollTop = bottom - rail.clientHeight + fade;
        }
      });
      railCue();
    }
    var ticking = false;
    track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; mark(); }); } }, { passive: true });
    if (rail) {
      rail.addEventListener('click', function (e) { var t = e.target.closest('[data-ehq-thumb]'); if (!t) return; var i = thumbs().indexOf(t); if (i >= 0) go(i, true); });
      rail.addEventListener('scroll', railCue, { passive: true });
      $$('.rail-step', rail.parentNode).forEach(function (s) { s.addEventListener('click', function () { rail.scrollBy({ top: (s.dataset.dir === 'next' ? 1 : -1) * rail.clientHeight * 0.6, behavior: 'smooth' }); }); });
    }
    if (dots) dots.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) go(Number(b.dataset.i), true); });
    window.addEventListener('resize', function () { go(index(), false); railCue(); });
    buildDots(); mark();
    return {
      showVariant: function (v, fromUser) {
        var changed = false;
        $$('[data-ehq-slide][data-basic]', track).forEach(function (s) { var hide = Number(s.dataset.mediaId) !== v.media; if (s.hidden !== hide) { s.hidden = hide; changed = true; } });
        if (rail) $$('[data-ehq-thumb][data-basic]', rail).forEach(function (t) { t.hidden = Number(t.dataset.mediaId) !== v.media; });
        if (changed) buildDots();
        if (fromUser && v.media) { var k = slides().map(function (s) { return Number(s.dataset.mediaId); }).indexOf(v.media); if (k >= 0) go(k, false); }
        mark();
      }
    };
  })();

  /* Unified sticky Add to Cart bar: appears once the main button has scrolled away, adds the selected variant and opens the drawer. */
  var bar = $('[data-ehq-sbar]', section), barButton = bar && $('[data-ehq-sbar-add]', bar);
  if (bar && atc) {
    var measureBar = function () { var was = bar.classList.contains('is-on'); setVar('--ehq-sbar-h', bar.getBoundingClientRect().height || 76); return was; };
    measureBar();
    if (window.ResizeObserver) new ResizeObserver(measureBar).observe(bar);
    var show = function (on) {
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (barButton) barButton.tabIndex = on ? 0 : -1;
    };
    var check = function () { var r = atc.getBoundingClientRect(); show(r.bottom < 0); };
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
    if (barButton) barButton.addEventListener('click', function () { if (form) addToCart(form, barButton); });
  }

  /* Alert bar "Apply": adds the selected variant, as the main button does. */
  $$('[data-ehq-apply]').forEach(function (b) { b.addEventListener('click', function () { if (form) addToCart(form, b); }); });

  if (current) paintPrices(current);
})();
